
import Opportunity from '@/models/Opportunity'
import ViewModel from '@/models/ViewModel'
import {
  Component, Prop, Ref, Vue, Watch,
} from 'vue-property-decorator'
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import { currencyMask } from '@/models/interface/Masks'
import WebMessage from '@/models/WebMessage'
import MediaPlan from '@/models/MediaPlan'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'

@Component({
  components: {
    DatePicker,
    FormInput,
    SelectPicker,
  },
})
export default class statusChange extends ViewModel {
  @Ref()
  public lost_validator!: any

  @Ref()
  public readonly stageChanger!: any

  @Prop({ required: true })
  public item!: any

  @Prop({ required: false })
  public disabled!: boolean

  @Prop({ required: true })
  public onlyEdit!: Array<any>

  @Prop({ required: true })
  public refreshAll!: boolean

  @Watch('refreshAll', { immediate: true })
  public onRefreshAll(val: boolean) {
    if (val) {
      this.temp_opportunity = Opportunity.toObject(this.item)
    }
  }

  public lost_categories: any = Opportunity.option_list.lost_categories

  public openPopOver: boolean = false

  public loading: boolean = false

  public id: any = this.randomUUID()

  public stauts_list = Opportunity.opportunity_status_text.filter((o: any) =>
    ['pitched', 'expected', 'consideration', 'processing', 'lost'].includes(o.value))

  public temp_opportunity: Opportunity = new Opportunity()

  public selected_targeting: boolean = false

  public check_media_plan: boolean = false

  public checking_media_plan: boolean = false

  public cant_be_saved: boolean = false

  public media_plan!: MediaPlan

  public updateStatus(status: string) {
    this.$root.$emit('bv::hide::popover', `status-popover-${this.item.id}-${this.id}`)

    if (status === 'lost') {
      let canSaveNow = this.checkMediaPlanOnLost()
      if (!canSaveNow) {
        return
      }
    }

    this.loading = true
    this.temp_opportunity.status = status
    Opportunity.forceStatusUpdate(this.temp_opportunity, 'status').then(res => {
      this.loading = false
      this.openPopOver = false
      this.selected_targeting = false
      this.$emit('saved')
    })
  }

  public get masks() {
    return {
      currency: currencyMask,
    }
  }

  public mounted() {
    this.temp_opportunity = Opportunity.toObject(this.item)

    this.$root.$on('bv::popover::show', (bvEventObj: any) => {
      if (bvEventObj.componentId !== `status-popover-${this.item.id}-${this.id}`) {
        this.openPopOver = false
      }
    })
  }

  public showWarning() {
    if (this.onlyEdit.includes(this.item.status)) {
      return
    }

    if (this.item.status === 'targeting') {
      WebMessage.warning('To move the status above targeting, please request a media plan.')
    } else {
      WebMessage.warning(
        'The status can not be updated, it will be automatically updated with the media plan.',
      )
    }
  }

  public updateToLost() {
    this.loading = true
    this.temp_opportunity.status = 'lost'
    this.temp_opportunity.percentage = 0

    Opportunity.forceStatusUpdate(this.temp_opportunity, 'status').then(res => {
      this.$emit('saved')
      this.resetOppMPSearch()
    })
  }

  public resetOppMPSearch() {
    this.check_media_plan = false
    this.loading = false
    this.cant_be_saved = false
    this.selected_targeting = false
  }

  public checkMediaPlanOnLost() {
    if (this.item.main_media_plan_id) {
      this.check_media_plan = true
      this.checking_media_plan = true

      MediaPlan.find(this.item.main_media_plan_id).then((response: MediaPlan) => {
        this.media_plan = response
        if (
          response.metrics
          && response.metrics.hasOwnProperty('impressions')
          && response.metrics.impressions > 0
        ) {
          this.cant_be_saved = true
          this.checking_media_plan = false
        } else {
          this.cant_be_saved = false
          this.checking_media_plan = false
        }
      })

      return false
    }

    return true
  }
}
